// 类型定义
interface ErrorInfo {
  errorMessage: string;
  scriptURI: string;
  lineNo: number;
  columnNo: number;
  error: string;
}

interface ProxyCall {
  [method: string]: (args: any) => Promise<any>;
}

interface MessageData {
  method: string;
  args: any;
  callback?: string;
}

interface Config {
  realVersionCode?: number;
  version?: string;
  gaid?: string;
  afId?: string;
  androidId?: string;
}

window.onerror = function (
  errorMessage: string | Event,
  scriptURI?: string,
  lineNo?: number,
  columnNo?: number,
  error?: Error
): boolean {
  const errobj: ErrorInfo = {
    errorMessage: errorMessage.toString(),
    scriptURI: scriptURI?.toString() || "",
    lineNo: lineNo || 0,
    columnNo: columnNo || 0,
    error: error + "",
  };
  // to report
  console.log(errobj);
  return false;
};
const _proxy_calls: ProxyCall = {};
window._proxy_call = async (method: string, args: any) => {
  const m = _proxy_calls[method];
  if (!m) return;
  const resp = await m(args);
  // delete _proxy_calls[method];
  await LtProxy.postMessage(
    { method: "_callback_" + method, args: { result: resp } },
    () => {}
  );
  return resp;
};
async function sleep(t: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(undefined);
    }, t);
  });
}
window.webviewCallback = function (data: MessageData) {
  LtProxy.rnInvokeWebMethod(data.callback || "", data.args);
};

const appTest = false;

export function initAppTest() {
  if (window.location.hostname.indexOf("localhost") < 0) return;
}

class LtProxyClass {
  [key: string]: any;
  h5Mode: boolean = false;
  __GLOBAL_FUNC_INDEX__: number = 0;
  APP_TYPE: string = "flutter";
  config: Config | null = null;
  isGpDomain(): boolean {
    if (appTest) return true;
    return window.gpDomain || false;
  }
  isActive(): boolean {
    try {
      if (appTest) return true;
      if (typeof window.flutter_inappwebview !== "undefined") {
        this.APP_TYPE = "flutter";
        return true;
      } else if (typeof window.ReactNativeWebView !== "undefined") {
        this.APP_TYPE = "rn";
        return true;
      } else {
        return false;
      }
    } catch {
      return false;
    }
  }
  async postMessage(
    msg: MessageData,
    callback: (resp: any) => void
  ): Promise<void> {
    if (this.APP_TYPE === "flutter") {
      await this.flutterPostMessage(msg, callback);
    } else if (this.APP_TYPE === "rn") {
      this.rnPostMessage(msg, callback);
    }
  }
  async flutterPostMessage(
    msg: MessageData,
    callback: (resp: any) => void
  ): Promise<void> {
    while (
      !window.flutter_inappwebview ||
      !window.flutter_inappwebview.callHandler
    ) {
      await sleep(100);
    }
    const resp = await window.flutter_inappwebview.callHandler("XXProxy", msg);
    callback(resp);
  }
  async rnPostMessage(
    msg: MessageData,
    callback: (resp: any) => void
  ): Promise<void> {
    while (
      !window.ReactNativeWebView ||
      !window.ReactNativeWebView.postMessage
    ) {
      await sleep(100);
    }
    let callbackName;
    if (typeof callback === "function") {
      callbackName = "__CALLBACK__" + this.__GLOBAL_FUNC_INDEX__++;
      this[callbackName] = callback;
    }
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ ...msg, callback: callbackName })
    );
  }
  rnInvokeWebMethod(callback: string, args: any): void {
    if (typeof callback === "string") {
      const func = this[callback];
      if (typeof func === "function") {
        setTimeout(() => {
          func.call(this, args);
        }, 0);
      }
    }
  }
  /**
   * 监听flutter回调
   * @param {*} methodName
   * @param {*} callback
   */
  setListener(methodName: string, callback: (args: any) => Promise<any>): void {
    _proxy_calls[methodName] = callback;
  }

  clearListener(methodName: string): void {
    delete _proxy_calls[methodName];
  }

  launchUrl(url: string): Promise<void> {
    if (!this.isActive()) {
      window.open(url);
      return Promise.resolve();
    }
    return new Promise(resolve => {
      this.postMessage({ method: "launchUrl", args: { url: url } }, () => {
        resolve(undefined);
      });
    });
  }

  async getConfig(): Promise<Config> {
    return new Promise(resolve => {
      if (this.config) {
        resolve(this.config);
      }
      this.postMessage({ method: "deviceInfo", args: {} }, resp => {
        this.config = resp;
        resolve(resp);
      });
    });
  }

  openAppWindow({
    top = 100,
    title = "",
    url = "",
    fullScreen = false,
    script,
  }: {
    top?: number;
    title?: string;
    url?: string;
    fullScreen?: boolean;
    script: string;
  }) {
    return new Promise(resolve => {
      this.postMessage(
        { method: "onPopup", args: { top, title, url, fullScreen, script } },
        () => {
          resolve(undefined);
        }
      );
    });
  }

  isVersionActive(version: number) {
    if (!this.isActive()) return false;
    if (!this.config?.realVersionCode) return false;
    if (this.config.realVersionCode < version) return false;
    return true;
  }

  enterFullScreen() {
    if (!this.isVersionActive(113)) return;
    return new Promise(resolve => {
      this.postMessage({ method: "enterFullScreen", args: {} }, () => {
        resolve(undefined);
      });
    });
  }

  exitFullScreen() {
    if (!this.isVersionActive(113)) return;
    return new Promise(resolve => {
      this.postMessage({ method: "exitFullScreen", args: {} }, () => {
        resolve(undefined);
      });
    });
  }

  landScreen() {
    if (!this.isVersionActive(113)) return;
    return new Promise(resolve => {
      this.postMessage({ method: "landScreen", args: {} }, () => {
        resolve(undefined);
      });
    });
  }

  portScreen() {
    if (!this.isVersionActive(113)) return;
    return new Promise(resolve => {
      this.postMessage({ method: "portScreen", args: {} }, () => {
        resolve(undefined);
      });
    });
  }
}

export const LtProxy = new LtProxyClass();
